import { render, staticRenderFns } from "./MovieCard.vue?vue&type=template&id=720099e8&"
import script from "./MovieCard.vue?vue&type=script&lang=js&"
export * from "./MovieCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports